import React from 'react';
import { StudioPlanCodes } from '@landr/pricing';
import { withInteractionSource } from 'contexts/InteractionSourceContext';
import { usePurchaseControllerContext } from 'contexts/PurchaseControllerContext/PurchaseControllerContext';
import { useMilestonesController } from 'controllers/business/Milestones/Milestones.controller';
import { ModalProps } from 'modals/Modal.types';
import { InteractionSource } from 'utils/analytics/AnalyticsV2Service.generated';
import { useBreakpoint } from '@landr/maestro';
import { ModalCloseHandler } from '../Modal.types';
import UpsellActions from './components/UpsellActions/UpsellActions';
import SplitModal from './components/SplitModal/SplitModal';
import DescriptiveFreeUpsell from './components/DescriptiveFreeUpsell/DescriptiveFreeUpsell';

const useFreeUserFreeDownloadUpsell = ({
    handleClose,
    cancelPurchase,
    perform,
}: {
    isModalOpen: boolean;
    handleClose: ModalCloseHandler;
    cancelPurchase: () => void;
    perform: (flag: string, shouldUpdateSession?: any) => void;
}) => {
    const handleCloseWithAnalytics = (): void => {
        handleClose();
        cancelPurchase();
        perform('FreeDownloadFreeUserUpsellViewed');
    };

    return { handleCloseWithAnalytics };
};

type FreeUserFreeDownloadUpsellModalProps = ModalProps;
const FreeUserFreeDownloadUpsellModal: React.FC<
    FreeUserFreeDownloadUpsellModalProps
> = ({ isOpen, handleClose }) => {
    const { perform } = useMilestonesController();
    const { cancelPurchase } = usePurchaseControllerContext();

    const { handleCloseWithAnalytics } = useFreeUserFreeDownloadUpsell({
        isModalOpen: isOpen,
        handleClose,
        perform,
        cancelPurchase,
    });
    const isMobile = useBreakpoint('md');

    return (
        <SplitModal isOpen={isOpen} onClose={handleCloseWithAnalytics}>
            {!isMobile && <DescriptiveFreeUpsell />}
            <UpsellActions
                offeredStudioPlanCode={StudioPlanCodes.StudioStandard}
                showBasicDownload={true}
            />
        </SplitModal>
    );
};

export default withInteractionSource(
    FreeUserFreeDownloadUpsellModal,
    InteractionSource.UpsellModalBasicDownload,
);
